import { useState } from "react";

export const useWizardState = () => {
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [campaniaSeleccionada, setCampaniaSeleccionada] = useState(null);
  const [claveSupervisor, setClaveSupervisor] = useState("");

  const [mostrarFormularioValidador, setMostrarFormularioValidador] = useState(false);
  const [mostrarResultados, setMostrarResultados] = useState(false);

  const [loadingBusqueda, setLoadingBusqueda] = useState(false);
  const [loadingAutorizacion, setLoadingAutorizacion] = useState(false);

  return {
    clienteSeleccionado, setClienteSeleccionado,
    campaniaSeleccionada, setCampaniaSeleccionada,
    claveSupervisor, setClaveSupervisor,
    mostrarFormularioValidador, setMostrarFormularioValidador,
    mostrarResultados, setMostrarResultados,
    loadingBusqueda, setLoadingBusqueda,
    loadingAutorizacion, setLoadingAutorizacion,
  };
};
